// extracted by mini-css-extract-plugin
export default {"navigation":"styles_navigation__npXUX","item":"styles_item__+fbyH","arrow":"styles_arrow__pwWy3","active":"styles_active__QkKIl","icons":"styles_icons__t8Wgz"};